import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

// Template136: Día 4 - Seongsu y Gangnam (Template136)
const Template136 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const introText = page?.texts?.[1]?.content;
	const heroTitle = page?.texts?.[2]?.content;
	const seongsuTitle = page?.texts?.[3]?.content;
	const seongsuDesc = page?.texts?.[4]?.content;
	const comoLlegarTitle = page?.texts?.[5]?.content;
	const comoLlegarText = page?.texts?.[6]?.content;
	const tipCafe = page?.texts?.[7]?.content;
	const gangnamTitle = page?.texts?.[8]?.content;
	const gangnamDesc = page?.texts?.[9]?.content;
	const starfieldTitle = page?.texts?.[10]?.content;
	const starfieldDesc = page?.texts?.[11]?.content;
	const sabiasQueLibro = page?.texts?.[12]?.content;
	const sabiasQueKdrama = page?.texts?.[13]?.content;
	const sabiasQueCoex = page?.texts?.[14]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const libreriaImage = getImageSrc("libreria");
	const gangnamSticker = getCanvasImageUrl("gangnam-sticker");
	const cafeImage = getCanvasImageUrl("cafe");
	const librarySticker = getCanvasImageUrl("library-sticker");
	const logoImage = getCanvasImageUrl("logo");

	const actualHeaderColor = headerBackgroundColor || "#2E8B80";

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": {
					marginTop: "0px !important",
					marginBottom: "0px !important",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{(portadaImage || heroTitle || gangnamSticker) && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					{portadaImage && (
						<img
							src={portadaImage}
							alt=""
							style={{ width: "100%", height: 200, objectFit: "cover" }}
						/>
					)}
					{gangnamSticker && (
						<img
							src={gangnamSticker}
							alt=""
							style={{ width: 100, position: "absolute", bottom: 55, left: 21 }}
						/>
					)}
					{heroTitle && (
						<Box
							component="h1"
							sx={{
								fontFamily: `${fontFamily || "'Poppins', sans-serif"}`,
								fontSize: isSmallScreen ? "28px" : "32px",
								textAlign: "center",
								position: "absolute",
								bottom: "0",
								margin: "10px",
								left: "20px",
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{heroTitle}
						</Box>
					)}
				</Box>
			)}

			{introText && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px 0px" }}>
					<Box
						component="p"
						sx={{
							fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
							fontSize: 13,
							color: "#333",
							margin: 0,
							padding: 0,
						}}
					>
						{introText}
					</Box>
				</Box>
			)}

			<Box sx={{ padding: "0 12px 12px" }}>
				{(seongsuTitle || seongsuDesc) && (
					<Box
						data-block-id="text-2"
						sx={{
							display: "flex",
							gap: "20px",
							alignItems: "flex-start",
							marginBottom: "16px",
						}}
					>
						<Box>
							{seongsuTitle && (
								<Box
									component="h3"
									sx={{
										fontFamily: "'Poppins', sans-serif",
										marginBottom: "4px",
										fontSize: 14,
										fontWeight: 700,
										textTransform: "uppercase",
									}}
								>
									{seongsuTitle}
								</Box>
							)}
							{seongsuDesc && (
								<Box
									component="p"
									sx={{
										fontFamily: "'Poppins', sans-serif",
										fontSize: 13,
										color: "#444",
									}}
								>
									{seongsuDesc}
								</Box>
							)}
						</Box>
					</Box>
				)}

				{(comoLlegarTitle || comoLlegarText) && (
					<Box
						data-block-id="text-3"
						sx={{
							backgroundColor: "#caeae6",
							border: "3px solid #2e8b80",
							borderRadius: "12px",
							padding: "16px 20px",
							fontSize: 12,
							fontFamily: "'Poppins', sans-serif",
							color: "#333",

							position: "relative",
							marginBottom: 0,
						}}
					>
						<Box sx={{ width: isSmallScreen ? "60%" : "100%" }}>
							{comoLlegarTitle && (
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: "8px",
										fontSize: 13,
										fontWeight: 700,
										display: "flex",
										alignItems: "center",
										gap: 6,
										color: "#2e8b80",
										textTransform: "uppercase",
									}}
								>
									{comoLlegarTitle}
								</Box>
							)}
							{comoLlegarText && (
								<Box
									component="ul"
									sx={{ paddingLeft: "20px", margin: 0, lineHeight: 1.5 }}
								>
									{comoLlegarText
										.split(". ")
										.map((line, i) => (line ? <li key={i}>{line}</li> : null))}
								</Box>
							)}
						</Box>
						{cafeImage && (
							<img
								src={cafeImage}
								alt=""
								style={{
									width: 100,
									position: "absolute",
									bottom: 0,
									right: isSmallScreen ? -20 : 0,
								}}
							/>
						)}
						{tipCafe && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? 75 : 50,
									right: isSmallScreen ? -10 : 80,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: 11,
									fontFamily: "'Poppins', sans-serif",
									color: "#444",
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: isSmallScreen ? 150 : 200,
								}}
							>
								{tipCafe}
							</Box>
						)}
					</Box>
				)}

				{(gangnamTitle || gangnamDesc) && (
					<Box data-block-id="text-4" sx={{ position: "relative", marginTop: "8px" }}>
						{gangnamTitle && (
							<Box
								component="h3"
								sx={{
									fontFamily: "'Poppins', sans-serif",
									marginBottom: "4px",
									fontSize: 14,
									fontWeight: 700,
									textTransform: "uppercase",
								}}
							>
								{gangnamTitle}
							</Box>
						)}
						{gangnamDesc && (
							<Box
								component="p"
								sx={{ fontSize: 13, fontFamily: "'Poppins', sans-serif" }}
							>
								{gangnamDesc}
							</Box>
						)}
					</Box>
				)}

				{(starfieldTitle || starfieldDesc || libreriaImage) && (
					<Box
						data-block-id="text-5"
						sx={{
							flex: 1,
							display: "flex",
							flexDirection: "column",
							gap: "16px",
							position: "relative",
							marginTop: "16px",
						}}
					>
						<Box
							sx={{ display: "flex", gap: "20px", alignItems: "flex-start" }}
						>
							{librarySticker && (
								<img
									src={librarySticker}
									alt=""
									style={{
										width: 100,
										position: "absolute",
										bottom: -30,
										left: -30,
									}}
								/>
							)}
							{libreriaImage && (
								<img
									src={libreriaImage}
									alt=""
									style={{
										width: "40%",
										height: 110,
										borderRadius: 12,
										objectFit: "cover",
									}}
								/>
							)}
							<Box sx={{ width: "60%" }}>
								{starfieldTitle && (
									<Box
										component="h3"
										sx={{
											fontFamily: "'Poppins', sans-serif",
											marginBottom: "4px",
											fontSize: 14,
											fontWeight: 700,
											textTransform: "uppercase",
											marginTop: "8px",
										}}
									>
										{starfieldTitle}
									</Box>
								)}
								{starfieldDesc && (
									<Box
										component="p"
										sx={{
											fontSize: 13,
											color: "#444",
											fontFamily: "'Poppins', sans-serif",
											margin: 0,
										}}
									>
										{starfieldDesc}
									</Box>
								)}
							</Box>
							{sabiasQueLibro && (
								<Box sx={{ position: "absolute", top: 80, left: "33%" }}>
									<SabiasQue
										icono="📚"
										texto={sabiasQueLibro}
										position="above"
									/>
								</Box>
							)}
							{sabiasQueKdrama && (
								<Box sx={{ position: "absolute", top: 30, left: "33%" }}>
									<SabiasQue icono="🎬" texto={sabiasQueKdrama} />
								</Box>
							)}
							{sabiasQueCoex && (
								<Box
									sx={{
										position: "absolute",
										top: isSmallScreen ? "-10px" : 0,
										left: isSmallScreen ? "30%" : "25%",
									}}
								>
									<SabiasQue icono="🛒" texto={sabiasQueCoex} />
								</Box>
							)}
						</Box>
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template136.thumbnail = "/images/template-1.png";

export default Template136;
